import { PropsWithChildren } from "react";
import ButtonWrapper from "components/utils/ButtonWrapper";
import { ButtonSize, Color, TooltipProps } from "utils/types/util.types";

type Props = {
	color?: Color
	link?: string
	onClick?: () => void
	outline?: boolean
	className?: string
	size?: ButtonSize
	tooltip?: TooltipProps
}

function Button({
	color = Color.BLUE,
	link,
	onClick,
	children,
	outline = false,
	className = "",
	size = ButtonSize.LARGE,
	tooltip,
}: PropsWithChildren<Props>) {

	return (
		<ButtonWrapper
			onClick={ onClick }
			link={ link }
			outline={ outline }
			className={ className }
			size={ size }
			color={ color }
			tooltip={ tooltip }
		>
			{ children }
		</ButtonWrapper>
	);
}

export default Button;